<template>
  <div
    class="card card-body mb-2 d-block"
    :id="`item-${item.id}`"
  >
    <div class="row">
      <div class="col-10">
        <v-item-content
          :item="item"
          :title="parsedTitle"
        />
      </div>
      <div v-if="isAddable" class="col-2">
        <div class="d-flex justify-content-end mb-2">
          <div class="d-flex flex-nowrap mb-2">
            <div class="mr-2">
              <v-button
                :id="`item-add-${item.id}`"
                icon="plus"
                style-type="secondary"
                size="xs"
                @click="$emit('add-item', item)"
                :title="$t('word.add')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import {
  EXCLUSIVE_RESPONSE_OPTIONS,
  isChoice,
  isMedia,
  isMultiChoice,
  isSingleChoice,
  parseItemTitleReplaceKeys,
} from '@/common/services/items';
import ItemContent from '@/organisation/components/research/ItemContent.vue';

export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAddable: {
      type: Boolean,
      default: false,
    },
    organisationName: {
      type: String,
      required: true,
    },
  },
  components: {
    'v-item-content': ItemContent,
    'v-button': Button,
  },
  methods: {
    isChoice,
    isMultiChoice,
    isSingleChoice,
    isMedia,
  },
  data() {
    return {
      EXCLUSIVE_RESPONSE_OPTIONS,
    };
  },
  computed: {
    options() {
      return this.item.options || [];
    },
    parsedTitle() {
      return `${parseItemTitleReplaceKeys(this.item.title, this.organisationName)}`;
    },
  },
};
</script>
